import NavigationBarComp from '../components/navigationBarComp';

const NavigationBar = () => {
    return <NavigationBarComp />;
};

export default NavigationBar;
